import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout, ProtectedRoutes } from "./components";
import {
  Register,
  Login,
  Home,
  ProductList,
  ProductDetails,
  UserCart,
  UserOrderDetails,
  UserOrdersList,
  UserProfile,
  UserReviewsList,
  EditProfile,
  AdminAnalytics,
  AdminChats,
  AdminCreateEditProduct,
  AdminUserDetails,
  AdminOrderDetails,
  AdminOrdersList,
  AdminProductsList,
  AdminUsersList,
  PageNotFound,
  AdminCategoriesList,
  AdminSettings,
  AdminAttributesList,
  AdminHome,
} from "./pages";
import { ScrollToTop } from "./utilities";
import { useSelector } from "react-redux";

export default function App() {
  const { isAdmin } = useSelector((state) => state.user);
  return (
    <BrowserRouter>
      <ScrollToTop />
      {/*on every new page (i.e. when pathname changes),scroll to top*/}
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<Layout admin={isAdmin} />}>
          {/* components below will be rendered inside the Layout component  */}
          <Route index element={<Home />}></Route>
          <Route path="/register" element={<Register />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route
            path="/product-details/:id"
            element={<ProductDetails />}
          ></Route>
          <Route path="/cart" element={<UserCart />}></Route>
          <Route
            path="/product-list/category/:categoryId"
            element={<ProductList />}
          ></Route>
          <Route path="/product-list" element={<ProductList />}></Route>
          <Route path="*" element={<PageNotFound />}></Route>
        </Route>

        {/* PROTECTED USER ROUTES -> return <Layout/> if logged in, else navigate to login*/}
        <Route element={<ProtectedRoutes admin={false} />}>
          <Route path="/user" element={<UserProfile />}></Route>
          <Route path="/user-edit-profile" element={<EditProfile />}></Route>
          <Route path="/user/my-reviews" element={<UserReviewsList />}></Route>
          <Route path="/user/my-orders" element={<UserOrdersList />}></Route>
          <Route
            path="/user/my-order-details/:id"
            element={<UserOrderDetails />}
          ></Route>
        </Route>

        {/* PROTECTED ADMIN ROUTES -> return <Layout/> if logged in, else navigate to login */}
        <Route element={<ProtectedRoutes admin={true} />}>
          <Route path="/admin" element={<AdminHome />}></Route>
          <Route path="/admin/users" element={<AdminUsersList />}></Route>
          <Route
            path="/admin/user-details/:id"
            element={<AdminUserDetails />}
          ></Route>
          <Route
            path="/admin/products-list"
            element={<AdminProductsList />}
          ></Route>
          <Route
            path="/admin/categories-list"
            element={<AdminCategoriesList />}
          ></Route>
          <Route
            path="/admin/attributes-list"
            element={<AdminAttributesList />}
          ></Route>
          <Route
            path="/admin/create-product"
            element={<AdminCreateEditProduct />}
          ></Route>
          <Route
            path="/admin/edit-product/:id"
            element={<AdminCreateEditProduct edit={true} />}
          ></Route>
          <Route path="/admin/chats" element={<AdminChats />}></Route>
          <Route path="/admin/analytics" element={<AdminAnalytics />}></Route>
          <Route path="/admin/orders" element={<AdminOrdersList />}></Route>
          <Route path="/admin/settings" element={<AdminSettings />}></Route>
          <Route
            path="/admin/order-details/:id"
            element={<AdminOrderDetails />}
          ></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
